import { render, staticRenderFns } from "./_aboutUs.vue?vue&type=template&id=0932fa5b&scoped=true&lang=pug&"
import script from "./_aboutUs.vue?vue&type=script&lang=js&"
export * from "./_aboutUs.vue?vue&type=script&lang=js&"
import style0 from "./_aboutUs.vue?vue&type=style&index=0&id=0932fa5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0932fa5b",
  null
  
)

export default component.exports